import React, { useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap-5';
import { fetchCallListExportCreditCounts } from '../../../helpers/prospect_api';
import LoadingBar from '../import/loading_bar';

type Props = {
  callListId: number,
  onHide: () => void,
  onOwnerUnlockComplete: () => void
}

export default function RethinkSyncModalContactUnlocking(
  { callListId, onHide, onOwnerUnlockComplete }: Props
) {

  const [progress, setProgress] = useState(0);
    
  useEffect(() => {
    const interval = setInterval(async () => {
      const data = await fetchCallListExportCreditCounts(callListId);
      if (data.creditsForExport === 0) {
        onOwnerUnlockComplete();
      } else {
        const percentComplete = (data.callListSize - data.creditsForExport) / data.callListSize * 100;
        setProgress(Math.floor(percentComplete));
      }
    }, 1500);
    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <Modal.Header closeButton>
        <h5 className="mb-0">Unlocking Contacts</h5>
      </Modal.Header>
      <Modal.Body>
        <div className="mb-2">
          We're currently unlocking all the contacts from the properties in this list to prepare them for Rethink.
        </div>
        <LoadingBar progress={progress} />  
      </Modal.Body>
      <Modal.Footer>
        <Button variant="link" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </>
  );
}
